module.exports = function() {
  return new Worker(__webpack_public_path__ + "445614f7c092c12feb6c.worker.js");
};